import { format } from "date-fns";
import { formatInTimeZone } from "date-fns-tz";
import { enGB } from "date-fns/locale";
import { ReactNode } from "react";
import { useAppSelector } from "../../../lib/redux/hooks";
import { formatDelay, getDelayColor } from "../../../lib/types";
import Pills from "../../../ui/molecoles/pills";


export function Rotation() {
    const reportState = useAppSelector(state => state.report)
    let list: ReactNode[] = []

    if (reportState.findByIdStatus === "successfully" &&
        reportState.findByIdResponse !== undefined &&
        reportState.findByIdResponse.flight_info !== undefined &&
        reportState.findByIdResponse.flight_info.flight !== undefined &&
        reportState.findByIdResponse.flight_info.flight.aircraft_rotation !== null &&
        reportState.findByIdResponse.flight_info.flight.aircraft_rotation.length > 0
    ) {
        reportState.findByIdResponse.flight_info.flight.aircraft_rotation.filter(flight => format(flight.departure.flight_gate_times.scheduled_out, "yyyy-MM-dd") !== "0001-01-01").forEach((item) => {
            list.push(
                <tr
                    className="bg-white h-[56px] border-b-[1px] border-b-neutral-100"
                >
                    <td
                        className="py-4 px-4 text-text-sm cursor-pointer font-semibold text-neutral-850"
                    >
                        <div className="flex flex-col gap-1 items-center">
                            {new Date(item.departure.flight_gate_times.scheduled_out).toISOString() === "0001-01-01T00:00:56.000Z"
                                ? "-"
                                : formatInTimeZone(item.departure.flight_gate_times.scheduled_out_tz, item.departure.airport.timezone, "dd MMM yyyy", { locale: enGB })
                            }
                            <Pills
                                size={"sm"}
                                label={item.history.diverted ? "Diverted" : item.history.cancelled ? "Canceled" : item.history.blocked ? "Blocked" : "Landed"}
                                outline={false}
                                emphasis={false}
                                color={(item.history.diverted || item.history.cancelled) ? "red" : item.history.blocked ? "orange" : "green"}
                            />
                        </div>
                    </td>
                    <td className="py-4 px-2 text-text-sm font-semibold text-neutral-800">
                        <div className="flex flex-col gap-[2px]">
                            <div className="flex flex-row gap-[4px] items-center">
                                <span>
                                    {item.ident_iata}
                                </span>
                                <span className="text-text-xs font-semibold text-neutral-600">
                                    {item.ident}
                                </span>
                            </div>
                            {item.operator + " " + item.airline_name}
                            <span className="font-semibold text-neutral-600">
                                {item.operator + "/" + item.operator_iata}
                            </span>
                        </div>
                    </td>
                    <td className="py-4 px-2 text-text-sm font-semibold text-neutral-800">
                        {item.departure.airport.city + " (" + item.departure.airport.code_iata + ")"}
                    </td>
                    <td className="py-4 px-2 text-text-sm font-semibold text-neutral-800">
                        {item.arrival.airport.city + " (" + item.arrival.airport.code_iata + ")"}
                    </td>
                    <td className="py-4 px-2 text-text-sm font-semibold text-neutral-600">
                        {format(item.departure.flight_gate_times.scheduled_out, "yyyy-MM-dd") === "0001-01-01"
                            ? "-"
                            : formatInTimeZone(item.departure.flight_gate_times.scheduled_out_tz, item.departure.airport.timezone, "dd MMM yyyy HH:mm", { locale: enGB }) +
                            " " +
                            item.departure.airport.timezone_abbr
                        }
                    </td>
                    <td className="py-4 px-2 text-text-sm font-semibold text-neutral-600">
                        <div className="flex flex-col gap-1 items-center">
                            {
                                (format(item.departure.flight_gate_times.actual_out, "yyyy-MM-dd") === "0001-01-01")
                                    ? "-"
                                    : formatInTimeZone(item.departure.flight_gate_times.actual_out_tz, item.departure.airport.timezone, "dd MMM yyyy HH:mm", { locale: enGB }) +
                                    " " +
                                    item.departure.airport.timezone_abbr
                            }
                            {
                                formatDelay(item.departure.flight_gate_times.departure_delay) && format(item.departure.flight_gate_times.actual_out, "yyyy-MM-dd") !== "0001-01-01" ?
                                    <Pills
                                        size={"sm"}
                                        label={formatDelay(item.departure.flight_gate_times.departure_delay)!}
                                        outline={false}
                                        emphasis={false}
                                        color={getDelayColor(item.departure.flight_gate_times.departure_delay)}
                                    />
                                    : format(item.departure.flight_gate_times.actual_out, "yyyy-MM-dd") !== "0001-01-01" ?
                                        <Pills
                                            size={"sm"}
                                            label={"On time"}
                                            outline={false}
                                            emphasis={false}
                                            color={"green"}
                                        /> : <></>
                            }
                        </div>
                    </td>
                    <td className="py-4 px-2 text-text-sm font-semibold text-neutral-600">
                        {format(item.arrival.flight_gate_times.scheduled_in, "yyyy-MM-dd") === "0001-01-01"
                            ? "-"
                            : formatInTimeZone(item.arrival.flight_gate_times.scheduled_in_tz, item.arrival.airport.timezone, "dd MMM yyyy HH:mm", { locale: enGB }) +
                            " " +
                            item.arrival.airport.timezone_abbr
                        }
                    </td>
                    <td className="py-4 px-2 text-text-sm font-semibold text-neutral-600">
                        <div className="flex flex-col gap-1 items-center">
                            {
                                (format(item.arrival.flight_gate_times.actual_in, "yyyy-MM-dd") === "0001-01-01" || item.history.cancelled) ? "-" :
                                    formatInTimeZone(item.arrival.flight_gate_times.actual_in_tz, item.arrival.airport.timezone, "dd MMM yyyy HH:mm", { locale: enGB }) +
                                    " " +
                                    item.arrival.airport.timezone_abbr
                            }
                            {
                                formatDelay(item.arrival.flight_gate_times.arrival_delay) && format(item.arrival.flight_gate_times.actual_in, "yyyy-MM-dd") !== "0001-01-01" ?
                                    <Pills
                                        size={"sm"}
                                        label={formatDelay(item.arrival.flight_gate_times.arrival_delay)!}
                                        outline={false}
                                        emphasis={false}
                                        color={getDelayColor(item.arrival.flight_gate_times.arrival_delay)}
                                    />
                                    : format(item.arrival.flight_gate_times.actual_in, "yyyy-MM-dd") !== "0001-01-01" ?
                                        <Pills
                                            size={"sm"}
                                            label={"On time"}
                                            outline={false}
                                            emphasis={false}
                                            color={"green"}
                                        /> : <></>
                            }
                        </div>
                    </td>
                </tr>
            )
        })
    }

    return (
        <div className={"flex gap-3 flex-col flex-grow"}>
            {/* <HeadingComponent
                label={"Aeroporto di " + reportState.findByIdResponse?.flight_info.flight.departure.airport.city! + " (" + reportState.findByIdResponse?.flight_info.flight.departure.airport.code_iata + ")"}
                buttons={[]}
                size={HeadingSize.SM}
            /> */}
            <div className="w-full flex flex-col gap-4 rounded-tr-xl rounded-tl-xl rounded-b-lg overflow-auto">
                <div>
                    <table className="w-full mb-3">
                        <thead className="h-[56px] bg-neutral-100 font-semibold text-neutral-500 text-text-xs">
                            <tr>
                                <th className="text-left">
                                    <div className="flex py-4 px-4 gap-1 justify-center">
                                        DATE/STATUS
                                    </div>
                                </th>
                                <th className="text-left">
                                    <div className="flex py-4 px-4 gap-1 justify-center">
                                        FLIGHT
                                    </div>
                                </th>
                                <th className="text-left">
                                    <div className="flex py-4 px-2 gap-1">
                                        DEPARTURE AIRPORT
                                    </div>
                                </th>
                                <th className="text-left">
                                    <div className="flex py-4 px-2 gap-1">
                                        ARRIVAL AIRPORT
                                    </div>
                                </th>
                                <th className="text-left">
                                    <div className="flex py-4 px-2 gap-1">
                                        SCHEDULED OUT
                                    </div>
                                </th>
                                <th className="text-left">
                                    <div className="flex py-4 px-2 gap-1 justify-center">
                                        ACTUAL OUT
                                    </div>
                                </th>
                                <th className="text-left">
                                    <div className="flex py-4 px-2 gap-1">
                                        SCHEDULED IN
                                    </div>
                                </th>
                                <th className="text-left">
                                    <div className="flex py-4 px-2 gap-1 justify-center">
                                        ACTUAL IN
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                reportState.findByIdResponse?.flight_info.flight.aircraft_rotation === null || reportState.findByIdResponse?.flight_info.flight.aircraft_rotation.length === 0 ?
                                    <tr className="bg-white h-[56px] border-b-[1px] border-b-neutral-100">
                                        <td className="py-4 px-4 text-text-sm font-semibold text-neutral-850">Result not available</td>
                                    </tr>
                                    :
                                    list
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    )
}